module.exports = __webpack_public_path__ + "static/media/_Dashboard Sidebar Item Master.c22536de.svg";